<template src="./template.html"></template>
<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import CostTable from '../../modules/01_costtable';
    import PageHeading from '../../modules/03_page_heading';
    import InputText from '../../cmp/inputText';
    import Select from '../../cmp/select';

    export default {
        components: { CostTable, PageHeading, InputText, Select },
        data () {
            return {
                showNamePublic: false,
                showTerms: this.$supplier.links.terms,
                selectList: [
                    { value: 'Firma', name: 'Firma' },
                    { value: 'Mr', name: 'Herr' },
                    { value: 'Mrs', name: 'Frau' },
                ],
                fixCity: false,
                showFirma: false,
                showAdditionalOrderInput: false,
                maxPanelsReachedError: false,
                limitError: false,
                // confirmEmail: null,
                errorsInput: {
                    salutation: false,
                    firstname: false,
                    lastname: false,
                    city: false,
                    street: false,
                    house_nr: false,
                    zip: false,
                    phone: false,
                    email: false,
                    confirmEmail: false,
                    orderAdditionalInfo: false,
                },
            };
        },
        computed: {
            ...mapGetters([
                'get_supplier', 'get_customer', 'get_max_panels', 'get_wording', 'get_building_info',
                'get_selected_panels', 'get_order_created', 'get_selection', 'get_selected_building_slug']),
            orderAdditionalFieldList: {
                get() {
                    const fields = this.get_supplier.settings.order_additonal_field;
                    return fields.split('|').map(f => ({
                        value: f,
                        name: f.toLowerCase() == 'other' ? 'andere' : f,
                    }));
                }
            }
        },
        props: ['step'],
        beforeMount () {
            this.$store.dispatch('UPDATE_STEPS', this.$props.step);
        },
        created () {
            // Check route to redirect
            if (this.get_order_created) {
                this.$router.push('/');
            } else if (this.get_selection.activeField === 0) {
                this.$router.push(`/${this.$route.params.buildingAddress}`);
            } else if (this.get_selected_panels.length === 0) {
                this.$router.push(`/${this.$route.params.buildingAddress}/step-2`);
            }

            if (this.get_customer.salutation.value === 'Firma') {
                this.showFirma = true;
            }

            if (this.get_selected_panels.length > 0) {
                if (this.get_selected_panels.some(p => p.owner.has)) {
                    this.fixCity = false;
                } else {
                    this.fixCity = this.get_supplier.settings.form_city !== '' && this.get_supplier.settings.form_city !== null;
                }
                this.$store.dispatch('SET_CUSTOMER', {
                    value: this.get_supplier.settings.form_city,
                    key: 'city',
                });
                
            }
        },
        methods: {
            toggleShowNamePublic () {
                this.showNamePublic = !this.showNamePublic;
            },
            handleRetrevedData (e, el) {
                this.$store.dispatch('SET_CUSTOMER', {
                    value: e.currentTarget.value,
                    key: el.selector,
                });
                this.errorsInput[el.selector] = false;

                if (el.selector === 'email' || el.selector === 'confirmEmail') {
                    if (this.customerObject().email !== this.customerObject().confirmEmail) {
                        this.errorsInput['confirmEmail'] = this.get_wording.error_email_match;
                    } else {
                        this.errorsInput['confirmEmail'] = false;
                    }
                }
            },

            selectChange (value, name) {
                this.showFirma = false;

                if (value === 'Firma') {
                    this.showFirma = true;
                }

                this.$store.dispatch('SET_CUSTOMER', {
                    value: {
                        value: value,
                        name: name,
                    },
                    key: 'salutation',
                });
                this.errorsInput.salutation = false;
            },
            selectOrderAdditionalInfoChange (value, name) {
                this.showAdditionalOrderInput = false;

                if (value.toLowerCase() === 'other') {
                    this.showAdditionalOrderInput = true;
                    return;
                }

                this.$store.dispatch('SET_CUSTOMER', {
                    value: name,
                    key: 'order_additional_info',
                });
                this.errorsInput.orderAdditionalInfo = false;
            },
            customerObject () {
                return {
                    salutation: this.get_customer.salutation.value,
                    company: this.get_customer.company,
                    firstname: this.get_customer.firstname,
                    lastname: this.get_customer.lastname,
                    street: this.get_customer.street,
                    house_nr: this.get_customer.house_nr,
                    zip: this.get_customer.zip,
                    city: this.get_customer.city,
                    phone: this.get_customer.phone,
                    email: this.get_customer.email,
                    confirmEmail: this.get_customer.confirmEmail,
                    order_additional_info: this.get_customer.order_additional_info,
                    selectedPanels: this.get_selected_panels.filter(p => p.owner.has === false).length,
                };
            },
            capitalizeTxt (txt) {
                return txt.charAt(0).toUpperCase() + txt.slice(1);
            },
            sendOrder () {
                this.validateCustomer().then(() => {
                    return this.createCustomer().then((customerId) => {
                        return this.createOrder(customerId);
                    });
                });
            },
            validateCustomer () {
                if (this.customerObject().email !== '' && this.customerObject().confirmEmail === '') {
                    this.errorsInput.confirmEmail = this.get_wording.error_required_mail;
                } else if (this.customerObject().confirmEmail !== this.customerObject().email) {
                    this.errorsInput['confirmEmail'] = this.get_wording.error_email_match;
                } else {
                    this.$store.dispatch('SET_LOADER', true);

                    const reqData = this.customerObject();
                    reqData.gift_panels = this.get_selected_panels.filter(p => p.owner.has).length;
                    reqData.own_panels = this.get_selected_panels.length - reqData.gift_panels;

                    return axios.post(this.$apiUrl + '/customer/validateOrder', reqData)
                    .then(response => response.data.success)
                    .catch((error) => {
                        this.$store.dispatch('SET_LOADER', false);
                        const resp = error.response.data;

                        if (resp.errors) {
                            var errors = error.response.data.errors;
                            window.scroll(0, 0);
                            // form exception
                            this.$store.dispatch('SET_NOTIFICATION', {
                                message: this.get_wording.fix_errors,
                                type: 'warning'
                            });

                            this.errorsInput = {};
                            for (var key in errors) {
                                this.errorsInput[key] = errors[key][0];
                                if (key === 'email') {
                                    this.errorsInput['confirmEmail'] = errors[key][0];
                                }
                            }
                        } else if (resp.data.limit_error) {
                            // limit exception
                            this.limitError = true;
                            let infoText = this.get_wording.module_nr_exceed;

                            if (resp.data.panels_left) {
                                infoText += `. ${this.capitalizeTxt(this.get_wording.free)}: ${resp.data.panels_left}`;
                            }

                            this.$store.dispatch('SET_NOTIFICATION', {
                                message: infoText,
                                type: 'warning'
                            });
                        }
                    });
                }
            },
            checkNumberOfAllowedPanels () {
                const reqParams = new URLSearchParams();
                for (let prop in this.customerObject()) {
                    reqParams.append(prop, this.customerObject()[prop]);
                }

                return axios.get(this.$apiUrl + '/customer/find', { params: reqParams })
                .then(response => response.data.data)
                .catch((error) => {
                    console.error(error.response.data.message);
                });
            },
            createCustomer () {
                return axios.post(this.$apiUrl + '/customer/save', this.customerObject())
                .then(response => response.data.data.id);
            },
            parseOwner (obj) {
                return {
                    city: obj.city,
                    company: obj.company,
                    email: obj.email,
                    firstname: obj.firstname,
                    house_nr: obj.house_nr,
                    lastname: obj.lastname,
                    phone: obj.phone,
                    salutation: obj.salutation.value,
                    street: obj.street,
                    zip: obj.zip,
                };
            },
            createOrder (customerId) {
                let panels = this.get_selected_panels.map(el => {
                    if (el.owner.has === true) {
                        return {
                            id: el.id,
                            name: el.panel_name,
                            owner: this.parseOwner(el.owner),
                        };
                    } else {
                        return {
                            id: el.id,
                            name: el.panel_name,
                            owner: {},
                        };
                    }
                });
                let order = {
                    'customer_id': customerId,
                    'show_name_public': this.showNamePublic,
                    'panels': panels,
                };
                axios.post(this.$apiUrl + '/order/create', order)
                .then((response) => {
                    this.$store.dispatch('SET_LOADER', false);
                    if (response.data.success === true) {
                        this.$store.dispatch('ORDER_CREATED');
                        this.$store.dispatch('UPDATE_PDF', {
                            download: response.data.data.pdf_url,
                            link: response.data.data.print_url,
                        });
                        this.$router.push('summary');
                    }
                })
                .catch((error) => {
                    const resp = error.response.data;
                    if (resp.data.limit_error) {
                        this.$store.dispatch('SET_NOTIFICATION', {
                            title: this.get_wording.module_limit,
                            message: `${resp.data.customer}: ${this.get_wording.module_nr_exceed}`,
                            type: 'warning'
                        });
                    } else {
                        this.$store.dispatch('SET_NOTIFICATION', {
                            message: this.get_wording.order_create_error,
                            type: 'warning'
                        });
                    }


                    this.$store.dispatch('SET_LOADER', false);
                });
            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/pages/04_customer/index.vue